export { default } from "./PlayerDetailLeftContainer";
